const audioCache = {
    audios: {
        'dice': new Audio('/app/audio/dice.mp3'),
        'notify': new Audio('/app/audio/notify.mp3'),
    },
    
    play: (key) => {
        audioCache.audios[key].play();
    }
}
export default audioCache;